import { cn } from "@roman/shared/utils";

interface TitleProps {
  text: string;
  className?: string;
}

export const Title = ({ text, className }: TitleProps) => {
  // Replace multiple consecutive newlines with single newlines
  const normalizedText = text.replace(/\n\s*\n/g, "\n");

  return (
    <div className="relative w-full group my-1">
      <div
        className={cn("line-clamp-2 leading-snug overflow-hidden text-ellipsis", className)}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          whiteSpace: "pre-line",
        }}
      >
        {normalizedText}
      </div>
    </div>
  );
};
